/*!

=========================================================
* Now UI Dashboard PRO React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Fragment } from "react";

// reactstrap components
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
//import { AppName } from "configs/app.json";
const AppName = require('configs/app.json').AppName;

// core components
// import PanelHeader from "components/PanelHeader/PanelHeader.jsx";

const Welcome = () => {
  return (
    <Fragment>
      {/* <PanelHeader size="sm" /> */}
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <h5 className="title">Welcome to {AppName}</h5>
              </CardHeader>
              <CardBody>Main Page</CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </Fragment>
  );
};

export default Welcome;
